
<div fxLayout="row" fxLayout.xs="column">
    <div class="class-mat-field" fxFlex="16.66">
        <mat-select placeholder="Country" [formControl]="countryControl" (selectionChange)="updateInstitution(true)">
            <input class="col-input-filter" [formControl]="searchCountryControl">
            <mat-option [value]="element['id']" *ngFor="let element of filteredCountries; let i = index">{{element['name']}}: {{element['full_name']}}</mat-option>
        </mat-select>
    </div>
    <div class="separator"></div>
    <div class="class-mat-field" fxFlex="16.66">
        <mat-select placeholder="Institution" [formControl]="institutionControl" class="multiselect" (selectionChange)="updateStructure(true)" multiple>
            <input class="col-input-filter" [formControl]="searchInstitutionControl">
            <mat-option [value]="element['id']" *ngFor="let element of filteredInstitutions; let i = index">
                <span class="mat-option-content">{{element['name']}}: {{element['full_name']}}</span>
                <span class="mat-option-checkbox">
                    <mat-icon *ngIf="selectedElement(institutionControl, element)" class="mat-icon material-icons check-icon" fontIcon="done"></mat-icon>
                </span>
            </mat-option>
        </mat-select>
    </div>
    
    <div class="separator"></div>
    <div class="class-mat-field" fxFlex="16.66">
        <mat-select placeholder="Structure" [formControl]="structureControl" class="multiselect" (selectionChange)="updateCycle(true)" multiple>
            <input class="col-input-filter" [formControl]="searchStructureControl">
            <mat-option [value]="element['id']" *ngFor="let element of filteredStructures; let i = index">
                <span class="mat-option-content">{{element['name']}}: {{element['full_name']}}</span>
                <span class="mat-option-checkbox">
                    <mat-icon *ngIf="selectedElement(structureControl, element)" class="mat-icon material-icons check-icon" fontIcon="done"></mat-icon>
                </span>
            </mat-option>
        </mat-select>
    </div>
     <div class="separator"></div>
    <div class="class-mat-field" fxFlex="16.66">
        <mat-select placeholder="Cycle" [formControl]="cycleControl" (selectionChange)="updateDepartment(true)">
            <input class="col-input-filter" [formControl]="searchCycleControl">
            <mat-option [value]="">Choose</mat-option>
            <mat-option [value]="element['id']" *ngFor="let element of filteredCycles; let i = index">{{element['name']}}: {{element['full_name']}}</mat-option>
        </mat-select>
    </div>
    <div class="separator"></div>
    <div *ngIf="showDepartment" class="separator"></div>
    <div *ngIf="showDepartment" class="class-mat-field" fxFlex="16.66">
        <mat-select placeholder="Department" [formControl]="departmentControl" class="multiselect" (selectionChange)="setDepartment()" multiple>
            <input class="col-input-filter" [formControl]="searchDepartmentControl">
            <mat-option [value]="element['id']" *ngFor="let element of filteredDepartments; let i = index">
                <span class="mat-option-content">{{element['name']}}: {{element['full_name']}}</span>
                <span class="mat-option-checkbox">
                    <mat-icon *ngIf="selectedElement(departmentControl, element)" class="mat-icon material-icons check-icon" fontIcon="done"></mat-icon>
                </span>
            </mat-option>
        </mat-select>
    </div>
    <div *ngIf="modes.length > 0" class="separator"></div>
    <div *ngIf="modes.length > 0" class="class-mat-field" fxFlex="8.33">
        <mat-select *ngIf="pageId != 'vca-manage-ressource'" class="class-select-field" placeholder="Mode" [formControl]="modeControl" class="multiselect" (selectionChange)="setMode()" multiple>
            <mat-option [value]="element['id']" *ngFor="let element of modes; let i = index">
                <span class="mat-option-content">{{element['value']}}</span>
                <span class="mat-option-checkbox">
                    <mat-icon *ngIf="selectedElement(modeControl, element)" class="mat-icon material-icons check-icon" fontIcon="done"></mat-icon>
                </span>
            </mat-option>
        </mat-select>
        <mat-select *ngIf="pageId == 'vca-manage-ressource'" placeholder="Mode" [formControl]="modeControl" (selectionChange)="setMode()">
            <mat-option [value]="element['id']" *ngFor="let element of modes; let i = index">{{element['value']}}</mat-option>
        </mat-select>
    </div>
    <div *ngIf="hasSearchKey" class="separator"></div>
    <div *ngIf="hasSearchKey" class="class-mat-field" fxFlex="8.33">
        <input type="text" class="col-input-filter" [formControl]="searchControl"  placeholder="Search" style="margin: 0;" value="">
    </div>
    <div class="separator"></div>
    <div class="class-mat-field" fxFlex="8.33"  fxLayoutAlign="center center">
        <button class="button-validate-small" (click) = "chargeData()">Validate</button>
    </div>
</div>